import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const sevSection = document.querySelector("section.sevelamer");
if (sevSection) {
  const mask = sevSection.querySelector("svg mask#circles-mask");
  const leftCircles = mask.querySelectorAll("circle:nth-child(even)");
  const rightCircles = mask.querySelectorAll("circle:nth-child(odd)");

  gsap.to(leftCircles, {
    y: "50%",
    duration: 1,
    ease: "power2.inOut",
    scrollTrigger: {
      trigger: sevSection,
      start: "top 50%",
      end: "bottom 50%",
      scrub: 2,
    },
  });

  gsap.to(rightCircles, {
    y: "-50%",
    duration: 1,
    ease: "power2.inOut",
    scrollTrigger: {
      trigger: sevSection,
      start: "top 50%",
      end: "bottom 50%",
      scrub: 2,
    },
  });
  const mobileCircles = sevSection.querySelectorAll(
    "svg mask#circles-mask-mobile circle"
  );
  gsap.to(mobileCircles, {
    x: "-200%",
    duration: 1.5,
    ease: "power2.inOut",
    scrollTrigger: {
      trigger: sevSection,
      start: "top 50%",
      end: "bottom top",
      scrub: 2,
    },
  });
}
